import { menuData } from 'Layout/LayoutMenuData';
import type { PermissionItem } from './permission';
import { filterMenuByPermissions } from './filterMenuByPermissions';

export const getAllowedMenu = (permissions: any[] | undefined, isAdmin: boolean) => {
  if (isAdmin) {
    return menuData;
  }

  return filterMenuByPermissions(permissions, menuData);
};

export const getFirstAllowedPath = (menu: any[]): string | null => {
  for (const item of menu) {
    if (item?.isTitle || item?.mobileOnly) continue;
    if (item?.link) return item.link;
    if (item?.subItems?.length) {
      const subPath = getFirstAllowedPath(item.subItems);
      if (subPath) return subPath;
    }
  }

  return null;
};

export const isPathAllowed = (menu: any[], currentPath: string): boolean => {
  for (const item of menu) {
    if (!item || item.isTitle) continue;

    if (
      item.link &&
      (item.link === currentPath ||
        currentPath.startsWith(`${item.link}/`) ||
        currentPath.startsWith(`${item.link}?`))
    ) {
      return true;
    }

    if (item.subItems?.length && isPathAllowed(item.subItems, currentPath)) {
      return true;
    }
  }

  return false;
};

export const hasFeaturePermission = (
  permissions: PermissionItem[] | undefined,
  feature?: string,
) => {
  if (!feature) return true;

  return Boolean(
    permissions?.some(
      (item) => item?.feature === feature && Number(item?.permissionMask || 0) > 0,
    ),
  );
};

export const hasAnyFeaturePermission = (
  permissions: PermissionItem[] | undefined,
  features?: string[],
) => {
  if (!features?.length) return true;

  return features.some((feature) => hasFeaturePermission(permissions, feature));
};